import Main from '../../types/enums/main';
import Slider from '../../classes/slider';
import slidersRequest from './slidersRequest';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

function slidersObservable(section = '') {
  return new Observable((subscriber) => {
    subscriber.next({
      type: Main.SLIDERS,
      data: [
        new Slider({ image: '', type: 'none' }, 0),
        new Slider({ image: '', type: 'none' }, 1),
        new Slider({ image: '', type: 'none' }, 2),
      ],
    });
    slidersRequest(section).then((data) => {
      setTimeout(() => {
        subscriber.next({ type: Main.SLIDERS, data });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}

export default slidersObservable;
